export default "__VITE_ASSET__n2_QzXR$__"